import { useLoaderData, Link } from "react-router";
import type { LoaderFunctionArgs } from "react-router";
import { getDiscipline } from "../lib/disciplines";
import { getPortfolio } from "../lib/portfolios";
import { HorizontalSequence } from "../components/portfolio/ScrollPortfolio";

export function meta({ data }: { data: Awaited<ReturnType<typeof loader>> }) {
  return [{ title: `${data.portfolio.title} — Captures by Mari` }];
}

export async function loader({ params }: LoaderFunctionArgs) {
  const discipline = getDiscipline(params.discipline!);
  if (!discipline) throw new Response("Not found", { status: 404 });
  const portfolio = getPortfolio(params.category!);
  if (!portfolio || portfolio.discipline !== discipline.slug) {
    throw new Response("Not found", { status: 404 });
  }
  return { discipline, portfolio };
}

export default function CategoryDeepDive() {
  const { portfolio } = useLoaderData<typeof loader>();
  return (
    <main className="py-12">
      <header className="max-w-7xl mx-auto px-6 mb-10 md:mb-14 flex flex-wrap items-end justify-between gap-6">
        <div><h1 className="page-title">{portfolio.title}</h1><p className="text-sm text-muted-foreground mt-5">{portfolio.images.length} photographs · Captures by Mari</p></div>
        <Link to="/work" className="font-camera text-xs text-primary hover:underline">All photos →</Link>
      </header>
      <HorizontalSequence images={portfolio.images} title={portfolio.title} id="series" />
    </main>
  );
}
